import {Box, Typography, useTheme,useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const legends = [
    {
        label:'Bradypnea',
        boarderColor:'#D1D3EA',
        backgroundColor:'#d1d3ea33'
    },
    {
        label:'Normal',
        boarderColor:'#34B3A8',
        backgroundColor:'#34b3a833'
    },
    {
        label:'Tachypnea',
        boarderColor:'#fb585a',
        backgroundColor:'#fb585a33'
    },
]

const RRChart = () => {

    
      
    // const data = {
    //     labels: ['12/6/23', '15/6/23', '21/7/23', '28/7/23', '5/8/23', '5/8/23', '27/10/23'],
    //     datasets: [
    //       {
    //         label: 'Respiratory rate (/min)',
    //         data:[
    //             {x:'12/6/23',y:14,rr:14,rrLabel:'low'},
    //             {x:'15/6/23',y:18,rr:18,rrLabel:'high'},
    //             {x:'21/7/23',y:12,rr:12,rrLabel:'normal'},
    //             {x:'28/7/23',y:23,rr:23,rrLabel:'normal'},
    //             {x:'5/8/23',y:20,rr:20,rrLabel:'high'},
    //             {x:'5/8/23',y:19,rr:19,rrLabel:'low'},
    //             {x:'27/10/23',y:10,rr:10,rrLabel:'normal'},
    //         ],
    //         borderColor: '#AA91F8',
    //         backgroundColor: '#AA91F8',
    //       },
    //     ],
    // };

    const theme = useTheme();
    const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));

    const [data,setData] = useState({
        labels: [],
        datasets: [
          {
            label: 'Respiratory rate (/min)',
            data:[
                // {x:'12/6/23',y:14,rr:14,rrLabel:'low'},
            ],
            borderColor: '#AA91F8',
            backgroundColor: '#AA91F8',
          },
        ],
    })

    const [minValue, setMinValue] = useState(1-1);
    const [maxValue, setMaxValue] = useState(100+20);

    const {
        pastVitalsData : {data:rawData,error,pastVitalsLoader}
    } = useSelector((state) => state.prescription);

    useEffect(()=>{
        if(rawData?.VITALS?.length){
            let rawDataArray = rawData?.VITALS?.find(elem=>elem.name=='rr');

            setMinValue(rawDataArray?.min < minValue ? rawDataArray?.min : minValue)
            setMaxValue(rawDataArray?.max > maxValue ? rawDataArray?.max : maxValue)
            
            if(rawDataArray?.values){
                let newData = data;
                rawDataArray?.values?.forEach(row=>{
                    let value = row?.value
                    if(value){
                        newData.labels.push(dayjs(row?.date,'YYYY-MM-DD').format('DD/MM/YYYY'));
                        newData.datasets[0].data.push({
                            x:dayjs(row?.date,'YYYY-MM-DD').format('DD/MM/YYYY'),
                            y:value,
                            rr:value,
                            rrLabel:row?.type
                        })
                    }
                })
                setData({...newData});
            }
        }
    },[rawData])

    const canvasBackgroundColor = {
        id:'canvasBackgroundColor',
        beforeDraw(chart,args,pluginOptions){
            const {ctx, chartArea: {top,bottom,left,right,width}, scales:{x,y}} = chart;

            
            ctx.save();

            colorBg(1,12,'#d1d3ea26');
            colorBg(12,20,'#34b3a826');
            colorBg(20,100,'#fb585a26');

            function colorBg(bracketLow,bracketHigh,color){
                ctx.fillStyle = color
                ctx.fillRect(left,y.getPixelForValue(bracketHigh), width, y.getPixelForValue(bracketLow)-y.getPixelForValue(bracketHigh))
                ctx.restore();
            }
        },
    }

    const options = {
        
        responsive: true,
        maintainAspectRatio: isMobileScreen ? false : true,
        plugins: {
            legend: {
                position: 'top',
                display:false
            },
            title: {
                display: false,
                text: 'RR Chart',
            },
            tooltip: {
                // Disable the on-canvas tooltip
                enabled: false,

                external: function(context) {
                    // Tooltip Element
                    let tooltipEl = document.getElementById('chartjs-tooltip');

                    // Create element on first render
                    if (!tooltipEl) {
                        tooltipEl = document.createElement('div');
                        tooltipEl.id = 'chartjs-tooltip';
                        tooltipEl.innerHTML = '<table></table>';
                        document.body.appendChild(tooltipEl);
                    }

                    // Hide if no tooltip
                    const tooltipModel = context.tooltip;
                    if (tooltipModel.opacity === 0) {
                        tooltipEl.style.opacity = 0;
                        return;
                    }

                    // Set caret Position
                    tooltipEl.classList.remove('above', 'below', 'no-transform');
                    if (tooltipModel.yAlign) {
                        tooltipEl.classList.add(tooltipModel.yAlign);
                    } else {
                        tooltipEl.classList.add('no-transform');
                    }

                    function getBody(bodyItem) {
                        return bodyItem.lines;
                    }

                    // Set Text
                    if (tooltipModel.body) {
                        const titleLines = tooltipModel.title || [];
                        const bodyLines = tooltipModel.body.map(getBody);

                        let innerHtml = '<thead>';

                        titleLines.forEach(function(title) {
                            innerHtml += '<tr><th>' + title + '</th></tr>';
                        });
                        innerHtml += '</thead><tbody>';

                        bodyLines.forEach(function(body, i) {
                            const colors = tooltipModel.labelColors[i];
                            let style = 'background:' + colors.backgroundColor;
                            style += '; border-color:' + colors.borderColor;
                            style += '; border-width: 2px';
                            const span = '<span style="' + style + '">' + body + '</span>';
                            innerHtml += '<tr><td>' + span + '</td></tr>';
                        });
                        innerHtml += '</tbody>';

                        let tableRoot = tooltipEl.querySelector('table');
                        tableRoot.style.padding = '8px'
                        tableRoot.style.backgroundColor = '#ffffff'
                        tableRoot.style.boxShadow = '1px 1px 4px #666666'


                        // tableRoot.innerHTML = innerHtml;

                        let rrLabelDotColor;
                        let rrLabelBackgroundColor;
                        switch(context?.tooltip?.dataPoints[0]?.raw?.rrLabel){
                            case 'normal':
                                rrLabelDotColor = '#34B3A8';
                                rrLabelBackgroundColor = '#34b3a833';
                                break;
                            case 'bradypnea':
                                rrLabelDotColor = '#D1D3EA';
                                rrLabelBackgroundColor = '#d1d3ea33';
                                break;
                            case 'tachypnea':
                                rrLabelDotColor = '#FF9A6C';
                                rrLabelBackgroundColor = '#ff9a6c33';
                                break;
                            default:
                                rrLabelDotColor = '#34B3A8';
                                rrLabelBackgroundColor = '#34b3a833';
                                break;
                        }

                        tableRoot.innerHTML = `
                            <thead>
                                <tr>
                                    <th>
                                        <div style="display:flex;justify-content:center; align-items:center ; background-color:${rrLabelBackgroundColor}; border-radius:36px; padding: 4px 32px;">
                                            <div style="margin-right:5px; width:6px; height:6px; border-radius:50%; background-color:${rrLabelDotColor};"></div>
                                            <div style="font-size:14px;">${context?.tooltip?.dataPoints[0]?.raw?.rrLabel?.charAt(0)?.toUpperCase() + context?.tooltip?.dataPoints[0]?.raw?.rrLabel?.slice(1)}</div>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style="display:flex; flex-direction:column; align-items:start;">
                                        <p style="color:#313131;font-size:10px; padding:0px; margin:0px;">Time</p>
                                        <p style="font-size:14px; padding:0px; margin:0px;font-weight:bold;">${context?.tooltip?.dataPoints[0]?.raw?.x}</p>
                                    </td>
                                <tr>
                                <tr>
                                    <td style="display:flex; flex-direction:column; align-items:start;">
                                        <p style="color:#313131;font-size:10px; padding:0px; margin:0px;">Respiratory Rate (RR)</p>
                                        <p style="font-size:14px; padding:0px; margin:0px;font-weight:bold;">${context?.tooltip?.dataPoints[0]?.raw?.rr}</p>
                                    </td>
                                <tr>
                            </tbody>
                        `;
                    }

                    const position = context.chart.canvas.getBoundingClientRect();
                    const tooltipX = position.left + window.pageXOffset + tooltipModel.caretX;
                    const chartWidth = context.chart.canvas.clientWidth;
                    const tooltipWidth = tooltipEl.clientWidth;

                    // Display, position, and set styles for font
                    tooltipEl.style.opacity = 1;
                    tooltipEl.style.position = 'absolute';
                    // If the tooltip is off the right side of the chart, position it to the left of the cursor
                    if (tooltipX + tooltipWidth > chartWidth) {
                        tooltipEl.style.left = (tooltipX - tooltipWidth) + 'px';
                    } else {
                        tooltipEl.style.left = tooltipX + 'px';
                    }
                    tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
                    tooltipEl.style.padding = tooltipModel.padding + 'px ' + tooltipModel.padding + 'px';
                    tooltipEl.style.pointerEvents = 'none';
                }
            }
          
        },
        scales:{
            y:{
                title:{
                    display:true, 
                    text:"Respiratory rate (/min)",
                    font:{
                        weight:'bold',
                        size: 14
                    },
                },
                min:minValue,
                max:maxValue,
                
                stacked:true,
                
                ticks: {
                    callback: function(val, index) {
                      return val < 0 ? this.getLabelForValue(val)?.replace('-','') : this.getLabelForValue(val);
                    },
                    stepSize: 3,
                },
                
            },
            x:{
                title:{
                    display:true, 
                    text:'Date',
                    font:{
                        weight:'bold',
                        size: 14
                    },
                },
                grid: {
                    display: false
                },
                stacked:true
            }
            
        },
        barThickness: 13
        
    };

    return (
        <Box height={'100%'} display={'flex'} flexDirection={'column'} alignItems={'center'}>
            <Box height={isMobileScreen?'300px' : '100%'} width={'100%'} display={'flex'} >
                <Bar
                    options={options}
                    data={data}
                    plugins={[canvasBackgroundColor]}
                />
            </Box>
            <Box display={'flex'} gap={2} mt={2}>
                {legends?.map(elem=>{
                    return (
                        <Box display={'flex'} alignItems={'center'} gap={1}>
                            <Box width={'13px'} height={'13px'} borderRadius={'50%'} border={`1px solid ${elem.boarderColor}`} backgroundColor={elem.backgroundColor}/>
                            <Typography variant='caption'>{elem.label}</Typography>
                        </Box>
                    )
                })}
            </Box>
        </Box>
    )
}

export default RRChart